import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as React from 'react';
import { BillPaymentStackRoutes, BillPaymentStackScreenProps } from '../../payment.navigator';
import { BillPaymentConfirmationModal } from './BillPaymentConfirmation.modal.web';
import { BillPaymentConfirmationStackParamList, BillPaymentConfirmationStackRoutes } from './type';

const BillPaymentConfirmStack = createNativeStackNavigator<BillPaymentConfirmationStackParamList>();

export const BillPaymentConfirmationNavigator: React.FC<BillPaymentStackScreenProps<BillPaymentStackRoutes.Confirmation>> = ({ route }) => {
  const { request: data, response, debitAccount, flagUploaded, documentSelected, paymentType } = route.params;
  return (
    <BillPaymentConfirmStack.Navigator
      initialRouteName={BillPaymentConfirmationStackRoutes.BillPaymentConfirm}
      screenOptions={{
        presentation: 'transparentModal',
        headerShown: false
      }}>
      <BillPaymentConfirmStack.Screen
        name={BillPaymentConfirmationStackRoutes.BillPaymentConfirm}
        component={BillPaymentConfirmationModal}
        initialParams={{ request: data, response, debitAccount, flagUploaded, documentSelected, paymentType }}
      />
    </BillPaymentConfirmStack.Navigator>
  );
};
